import algoliasearch from 'algoliasearch';


const AlgoliaClient = algoliasearch('C4LLHF0NB3', '60ab5e9b942799008fd79cca90851945');
const IssueIndex = AlgoliaClient.initIndex('issues');

export { IssueIndex };
export default AlgoliaClient;